import { render, staticRenderFns } from "./steelBoxGirder.vue?vue&type=template&id=1fe6424a&scoped=true&lang=pug"
import script from "./steelBoxGirder.vue?vue&type=script&lang=js"
export * from "./steelBoxGirder.vue?vue&type=script&lang=js"
import style0 from "./steelBoxGirder.vue?vue&type=style&index=0&id=1fe6424a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe6424a",
  null
  
)

export default component.exports